/** @jsxImportSource @emotion/react */

import React from 'react';
import { animated, useSpring } from 'react-spring';
import { AnimatedDelightProps } from './IAnimatedDelightProps';

export const AnimatedConfettiLeft = ({ endScale = 1, startScale = 0 }: AnimatedDelightProps) => {
  const style1 = useSpring({
    to: {
      transform: `rotate(0deg) scale3d(${endScale}, ${endScale}, ${endScale})`
    },
    from: {
      transform: `rotate(-180deg) scale3d(${startScale}, ${startScale}, ${startScale})`
    },
    delay: 600,
    config: {
      tension: 400,
      friction: 20
    }
  });

  const style2 = useSpring({
    to: {
      transform: `rotate(0deg) scale3d(${endScale}, ${endScale}, ${endScale})`
    },
    from: {
      transform: `rotate(-250deg) scale3d(${startScale}, ${startScale}, ${startScale})`
    },
    delay: 750,
    config: {
      tension: 400,
      friction: 20
    }
  });

  const style3 = useSpring({
    to: {
      transform: `rotate(0deg) scale3d(${endScale}, ${endScale}, ${endScale})`
    },
    from: {
      transform: `rotate(100deg) scale3d(${startScale}, ${startScale}, ${startScale})`
    },
    delay: 850,
    config: {
      tension: 400,
      friction: 20
    }
  });

  return (
    <div
      css={{
        height: '100%',
        left: '0',
        position: 'absolute',
        top: '300px',
        zIndex: -1
      }}
    >
      <svg
        css={{
          display: 'none',

          [`@media (min-width: 1050px)`]: {
            display: 'block',
            height: '290px',
            position: 'sticky',
            top: '500px',
            width: '245px',
          }
        }}
        width="180"
        height="220"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <animated.path
        css={{
            transformOrigin: '113px 185px'
        }}
        style={style3} d="M142.122 165.233l-25.811-14.338-29.93 53.881 25.811 14.338 29.93-53.881z" fill="#D7E100" />
        <animated.path
        css={{
            transformOrigin: '22px 100px'
        }}
        style={style2} d="M28.22 66.993L0 75.679l18.133 58.911 28.22-8.687-18.132-58.91z" fill="#F46508" />
        <animated.path
        css={{
            transformOrigin: '149px 35px'
        }}
        style={style1} d="M179.198 15.126L153.841 0l-31.575 52.932 25.356 15.126 31.576-52.932z" fill="#E43896" />
      </svg>
    </div>
  );
};
